const autoNgTemplateLoaderTemplate1 = require('./storidgeProfilesDatatable.html');

angular.module('shbdeployer.integrations.storidge').component('storidgeProfilesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
  },
});
